import ServicePageShell from "@/components/site/ServicePageShell";
export default function Patrimoine() { return <ServicePageShell slug="patrimoine" />; }
